import React from 'react'
import styles from './index.module.sass'

interface Props {
  settedRef: React.RefObject<HTMLDivElement>,
  show: boolean
}

const WaterTrack: React.FC<Props> = ({ settedRef, show }) => {
  return (
    <div className={`${styles.root} ${show ? styles.show : ''}`} ref={settedRef}>
      <svg 
        width="251"
        height="291"
        version="1.1" 
        className='watertsvg'
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          id="waterstartpath" 
          d="M198.834 214.437c-.15 18.079-13.941 26.001-26.944 23.287-13.089-2.73-19.887-9.166-19.887-24.731-1.65-51.812-21.6-105.168-79.999-111.346-4.323-.457-12.867-3.991-17.825-15.095-8.413-18.841 8.199-36.364 24.573-34.522 79.103 11.339 122.674 69.356 120.082 162.407zm-20.033-19.17c-11.959-1.961-20.956 4.518-22.922 16.509-1.965 11.99 4.491 21.003 16.451 22.964 11.959 1.96 20.956-4.519 22.922-16.509 1.965-11.991-4.491-21.004-16.451-22.964z" 
          // stroke="gray" 
          // strokeDasharray="5,5"
          fill="white"
        />
        <path 
          id="waterendpath" 
          // strokeWidth="7"
          d="m 76.687058,76.002352 c 0,0 28.553102,4.689749 42.451762,12.66706 11.91061,6.836242 22.39926,16.618908 30.46942,27.730588 6.03285,8.30654 9.64343,18.26215 12.66705,28.07294 3.10545,10.07632 6.02795,20.43065 7.87412,30.81177 2.82194,15.86789 5.47766,41.08234 5.47766,41.08234"
          // stroke="#7CFC00" 
          fill="transparent" 
          strokeLinecap="round"
        />
        {/* <path className='watersvgtarget' xmlns="http://www.w3.org/2000/svg" fill="#80d1a8" fillRule="evenodd" d="M17.199 1.267C29.158-.694 38.155 5.785 40.121 17.776c1.965 11.99-4.491 21.003-16.451 22.964C11.711 42.7 2.714 36.221.748 24.231-1.217 12.24 5.239 3.227 17.199 1.267z"/> */}
        <circle 
          className={`waterknob ${styles.levers_knob}`}
          r="21" 
          fill="#01a451" 
        />
        
      </svg>
    </div>
  )
}

export default WaterTrack
